// dialog.service.ts
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TherapistBreakDialog } from '../layouts/therapist-portal/therapist-portal.component'; // adjust path
import { TherapistDashboardService } from '.././services/api/TherapistDashboardService';

@Injectable({ providedIn: 'root' })
export class TherapistBreakDialogService {
  private therapistBreakDialogRef: MatDialogRef<any> | null = null;

  constructor(
    private dialog: MatDialog,
    private therapistDashboardService: TherapistDashboardService
  ) {}

  showTherapistOnBreakDialog(changeDate: Date): void {
    if (this.therapistBreakDialogRef) {
      return;
    }

    this.therapistBreakDialogRef = this.dialog.open(TherapistBreakDialog, {
      data: { changeDate },
      panelClass: 'therapist-portal-dialog',
      disableClose: true,
      backdropClass: 'dialog-blur',
    });

    this.therapistBreakDialogRef.afterClosed().subscribe(result => {
      this.therapistBreakDialogRef = null;
      if (result) {
        this.therapistDashboardService.endBreak().subscribe(); // handle error/success if needed
      }
    });
  }
}